import { css } from 'styled-components';
import token from 'styled-token';
import { StyledGleam } from '../../components/Gleam/Gleam.styles';
import { spaceMixin } from '../spaceMixin';

/** @class GleamWrapperMixin */
/** @method */
export var GleamWrapperMixin = function GleamWrapperMixin(props) {
  return token({
    positionTop: 'GleamWrapper.position.top',
    positionRight: 'GleamWrapper.position.right'
  }, function (_ref) {
    var positionTop = _ref.positionTop,
      positionRight = _ref.positionRight;
    return css(["display:inline-block;position:relative;", "{position:absolute;top:calc(-1 * ", ");right:calc(-1 * ", ");}"], StyledGleam, positionTop ? positionTop + "px" : spaceMixin('xs')(props), positionRight ? positionRight + "px" : spaceMixin('xs')(props));
  })(props);
};